import { render, staticRenderFns } from "./HomeFollowedTags.vue?vue&type=template&id=f40700e4&"
import script from "./HomeFollowedTags.vue?vue&type=script&lang=js&"
export * from "./HomeFollowedTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports